import React from "react";
import EmptyCart from '../assets/empty_cart.svg'
import { Link } from "react-router-dom";

const Cart = ({ cart, changeQuantity, removeItem }) => {
  // gets the total quantity * book quantity
  const total = () => {
    let price = 0;
    cart.forEach((item) => {
      price += +(
        (item.salePrice || item.originalPrice) * item.quantity
      ).toFixed(2);
    });
    return price;
  };

  const total_tax = () => {
    // console.log('');
    return total() * 0.07;
  };

  // check to see if the coupon match, not expired, and has not been used if true then take the discount off 
  // else if coupon doesn't match or code has expired or has been used then keep the original or sale price
  
  return (
    <div id="items__body">
      <main id="books__main">
        <div className="books__container">
          <div className="row">
            <div className="book__selected--top">
              <h2 className="cart__title">Cart</h2>
            </div>
            <div className="cart">
              <div className="cart__header">
                <span className="cart__book">Bicycle</span>
                <span className="cart__quanity">Quantity</span>
                <span className="cart__total">Total</span>
              </div>
              <div className="cart__body">
                {cart.map((bike) => {
                  return (
                    <div className="cart__item">
                      <div className="cart__book">
                        <img
                          src={bike.url}
                          alt="book-img"
                          className="cart__book--img"
                        />
                        <div className="cart__book--info">
                          <span className="cart__book--title">
                            {bike.title}
                          </span>
                          <span className="cart__book--price">
                            ${(bike.salePrice || bike.originalPrice).toFixed(2)}
                          </span>
                          <button
                            className="cart__book--remove"
                            onClick={() => removeItem(bike)}
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                      <div className="cart__quantity">
                        <input
                          type="number"
                          min={0}
                          max={99}
                          className="cart__input"
                          value={bike.quantity}
                          onChange={(event) =>
                            changeQuantity(bike, event.target.value)
                          }
                        />
                      </div>
                      <div className="cart__total">
                        $
                        {(
                          (bike.salePrice || bike.originalPrice) * bike.quantity
                        ).toFixed(2)}
                      </div>
                    </div>
                  );
                })}
              </div>
              {cart.length === 0 && (
                <div className="cart__empty">
                  <img
                    src={EmptyCart}
                    alt="Empty-img"
                    className="cart__empty--img"
                  />
                  <h2>You don't have any bicycle in your cart!</h2>
                  <Link to="/bikes">
                    <button className="btn">Browse Bicycle</button>
                  </Link>
                </div>
              )}
            </div>
            {/* If the user has a coupon display the box for the user to enter the coupon */}
            {cart.length > 0 && (
              <div className="total">
                {/* add coupon feature */}
                {/* when enter check then take off if none then display orginial or sale */}
                {/* <div className="total__item total__sub--total">
                  <span>Coupon</span>
                  <span>
                    <input 
                      type="text"
                      maxLength={15}
                      className="cart__coupon"
                    />
                  </span>
                </div> */}
                <div className="total__item total__sub--total">
                  <span>Subtotal</span>
                  <span>${total().toFixed(2)}</span>
                </div>
                <div className="total__item total__tax">
                  <span>Tax</span>
                  <span>${total_tax().toFixed(2)}</span>
                </div>
                <div className="total__item total__price">
                  <span>Total</span>
                  <span>${(total() + total_tax()).toFixed(2)}</span>
                </div>
                <button
                  className="btn btn__checkout no-cursor"
                  onClick={() => alert("Feature doesn't exist yet")}
                >
                  Proceed to checkout
                </button>
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default Cart;
